import { render, staticRenderFns } from "./bindPhoneStep2.vue?vue&type=template&id=6de044b5&scoped=true&"
import script from "./bindPhoneStep2.vue?vue&type=script&lang=js&"
export * from "./bindPhoneStep2.vue?vue&type=script&lang=js&"
import style0 from "./bindPhoneStep2.vue?vue&type=style&index=0&id=6de044b5&prod&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6de044b5",
  null
  
)

export default component.exports